import { useTheme } from 'styled-components'

// Presentational, read-only renderer for a warehouse's halls. Draws each hall (and
// sub-area) at its own local geometry — the caller supplies the enclosing
// `<g transform>` that maps the warehouse's local frame into the target space
// (e.g. a warehouse block on the Sites Map). Racks/paths/positions are omitted:
// halls are enough to recognise and orient a warehouse at site zoom.
function WarehouseHallsView({ halls, showLabels = false, opacity = 0.5 }) {
    const theme = useTheme()
    if (!halls?.length) return null
    return (
        <>
            {halls.map(h => {
                const g = h.geometry
                if (!g || !g.width || !g.height) return null
                const isArea = !!h.isArea
                const fill = h.color || (isArea ? theme.btn.primary : theme.area.bg)
                const border = Math.max(20, Math.min(g.width, g.height) * 0.015)
                return (
                    <g key={h.id} transform={`rotate(${-(g.rotation || 0)} ${g.x} ${g.y})`}>
                        <rect
                            x={g.x - g.width / 2}
                            y={g.y - g.height / 2}
                            width={g.width}
                            height={g.height}
                            fill={fill}
                            fillOpacity={isArea ? 0.16 : opacity}
                            stroke={isArea ? theme.btn.primary : theme.area.lightBorder}
                            strokeWidth={border}
                        />
                    </g>
                )
            })}
            {showLabels && halls.map(h => {
                const g = h.geometry
                if (!g || !g.width || !g.height) return null
                const fontSize = Math.max(100, g.width * 0.06)
                return (
                    <text
                        key={`lbl-${h.id}`}
                        transform={`rotate(${-(g.rotation || 0)} ${g.x} ${g.y})`}
                        x={g.x}
                        y={g.y}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontSize={fontSize}
                        fontWeight="600"
                        fill={theme.font.label}
                        pointerEvents="none"
                        style={{ userSelect: 'none' }}
                    >
                        {h.code || h.name}
                    </text>
                )
            })}
        </>
    )
}

export default WarehouseHallsView
